var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "detail"
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": _vm.breadcrumbs
    }
  }), _vm.loading && !_vm.subnetsLoaded ? _c('Loader', {
    attrs: {
      "content-id": _vm.id,
      "message": 'Fetching Blockchain Details'
    }
  }) : [_c('BlockchainSummary', {
    attrs: {
      "blockchain": _vm.blockchain
    }
  }), _vm.blockchain ? [_vm.blockchain.indexed ? _c('div', {
    staticClass: "card blockchain_tx"
  }, [_c('TxHeader'), _c('TxInteractive', {
    attrs: {
      "transactions": _vm.transactions,
      "assets-loaded": _vm.assetsLoaded,
      "loading": _vm.loading,
      "chains": _vm.chain
    },
    on: {
      "change": _vm.fetchTx
    }
  })], 1) : _vm._e()] : _vm._e()]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }